module.exports = __webpack_public_path__ + "static/media/anger.6ece8161.png";